import { render, staticRenderFns } from "./MultipleDepart.vue?vue&type=template&id=646920a8&scoped=true"
import script from "./MultipleDepart.vue?vue&type=script&lang=js"
export * from "./MultipleDepart.vue?vue&type=script&lang=js"
import style0 from "./MultipleDepart.vue?vue&type=style&index=0&id=646920a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646920a8",
  null
  
)

export default component.exports